import type Component from "./Component";

export function getSingleParameter(component: Component, slot: number): string | undefined {
  return component.parameters[slot]?.elements[1]?.values[1]?.value
}

export function getName(component: Component): string {
  return getSingleParameter(component, 1) ?? "Unknown?"
}